export const THREAD_ACTION_TYPES = {
  CHAT: 'CHAT',
  CHART: 'CHART',
  DOCUMENT: 'DOCUMENT',
  OCR: 'OCR',
}